import { z } from 'zod';
import { ModelId, ModelTier } from './model-profiles.js';
/** Short batch-local handle for a task in a plan, used by other tasks' `dependsOn`. */
export const PlanTaskRef = z.string().regex(/^[a-z0-9][a-z0-9-]{0,39}$/);
/** `viko_task_create_batch`: propose a whole plan (tasks + dependency graph) in one call. */
export const VikoTaskCreateBatchInput = z.object({
    plan: z.object({
        title: z.string().min(1).max(200),
        /** Repo-relative path of the plan doc. */
        doc: z.string().max(500).optional(),
    }),
    tasks: z
        .array(z.object({
        ref: PlanTaskRef,
        title: z.string().min(1).max(200),
        description: z.string().max(4000).optional(),
        acceptance: z.string().max(2000).optional(),
        labels: z.array(z.string()).max(20).default([]),
        tier: ModelTier.optional(),
        model: ModelId.optional(),
        modelReason: z.string().max(200).optional(),
        /** Batch refs or existing task ids. */
        dependsOn: z.array(z.string()).max(50).default([]),
        files: z.array(z.string().max(300)).max(100).optional(),
        risk: z.enum(['normal', 'high']).optional(),
    }))
        .min(1)
        .max(100),
});
export const VikoTaskCreateBatchOutput = z.object({
    planId: z.string(),
    /** ref -> created task id */
    taskIds: z.record(z.string(), z.string()),
    status: z.literal('proposed'),
});
/**
 * The plan a task belongs to, kept with the task (E2E: inside the sealed record; legacy: the task's
 * data JSON). Enough for an endpoint to rebuild the plan card: waves, tiers, deps and file conflicts.
 */
export const TaskPlanTag = z.strictObject({
    id: z.string().min(1).max(128),
    title: z.string().min(1).max(200),
    doc: z.string().max(500).optional(),
    ref: PlanTaskRef,
    files: z.array(z.string().max(300)).max(100).optional(),
    risk: z.enum(['normal', 'high']).optional(),
});
//# sourceMappingURL=plan-batch.js.map